import { render } from "./CRMstatistics.vue?vue&type=template&id=944a53d8&scoped=true"
import script from "./CRMstatistics.vue?vue&type=script&lang=js"
export * from "./CRMstatistics.vue?vue&type=script&lang=js"

import "./CRMstatistics.vue?vue&type=style&index=0&id=944a53d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-944a53d8"

export default script